import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relativ" }
const _hoisted_2 = { class: "bg-clay-100" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  "aria-label": "Breadcrumb",
  class: "hidden bg-opacity-50 border-b border-gray-200 bg-clay-900 lg:flex"
}
const _hoisted_5 = {
  class: "flex w-full max-w-screen-xl px-4 mx-auto space-x-4 sm:px-6 lg:px-8",
  role: "list"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  "aria-current": "page",
  class: "ml-4 text-sm font-semibold text-clay-50"
}
const _hoisted_9 = { class: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" }
const _hoisted_10 = { class: "py-8 mx-auto max-w-7xl" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "py-6 overflow-hidden text-center rounded-2xl" }
const _hoisted_13 = { class: "md:flex md:space-x-12" }
const _hoisted_14 = { class: "relative min-w-full mt-0 md:text-center md:-mt-5 md:pt-1" }
const _hoisted_15 = { class: "pt-0 mt-4 mb-2 text-2xl font-bold text-clay-950 mb:mt-8 md:text-4xl md:mt-0 mb:pt-4" }
const _hoisted_16 = { class: "text-lg font-medium md:mb-3 text-clay-900" }
const _hoisted_17 = {
  key: 0,
  class: "mt-4 space-y-3"
}
const _hoisted_18 = { class: "mb-3 space-x-2" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "items-center hidden text-center md:block" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "flex justify-center mt-0 space-x-3" }
const _hoisted_23 = { class: "inline-flex text-white rounded-md shadow-sm bg-opacity-40 isolate action-bar share-solo bg-clay-800" }
const _hoisted_24 = { class: "mx-auto max-w-7xl" }
const _hoisted_25 = { role: "main" }
const _hoisted_26 = { class: "mx-auto max-w-7xl" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "flex h-full min-h-screen" }
const _hoisted_29 = { class: "flex-1 min-w-0 overflow-visible md:flex sm:px-6 lg:px-8" }
const _hoisted_30 = { class: "z-0 flex flex-1 mb-12 overflow-visible sm:bg-white" }
const _hoisted_31 = { class: "relative z-0 flex-1 pt-6 overflow-y-auto focus:outline-hidden xl:order-last" }
const _hoisted_32 = { class: "relative inset-0 px-4 pb-6 sm:px-6 lg:px-8" }
const _hoisted_33 = { class: "h-full rounded-lg" }
const _hoisted_34 = { class: "pt-5 pl-4 pr-4 contentful-tab" }
const _hoisted_35 = { class: "guidesTab md:h-full" }
const _hoisted_36 = {
  key: 0,
  class: "justify-center min-w-full space-y-5 prose prose-lg prose-slate"
}
const _hoisted_37 = { class: "p-8 bg-gradient-to-b from-white via-white to-clay-500 rounded-xl" }
const _hoisted_38 = { class: "min-w-full text-lg text-transparent walled-teaser bg-clip-text bg-gradient-to-b from-clay-500 to-white" }
const _hoisted_39 = { class: "col-sm-12" }
const _hoisted_40 = { class: "p-2 m-0 font-semibold" }
const _hoisted_41 = {
  key: 0,
  class: "text-center row"
}
const _hoisted_42 = { class: "mb-3 col-md-12" }
const _hoisted_43 = { class: "p-0 m-0 text-center figure" }
const _hoisted_44 = ["alt", "src"]
const _hoisted_45 = { class: "text-clay-950/50" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_48 = ["for"]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "italic font-semibold" }
const _hoisted_53 = {
  key: 1,
  class: "justify-center min-w-full space-y-5"
}
const _hoisted_54 = { class: "col-sm-12" }
const _hoisted_55 = { class: "py-2 m-0" }
const _hoisted_56 = {
  key: 0,
  class: "text-center row"
}
const _hoisted_57 = { class: "mb-3 col-md-12" }
const _hoisted_58 = { class: "p-0 m-0 text-center figure" }
const _hoisted_59 = ["alt", "src"]
const _hoisted_60 = { class: "px-5 py-3 pl-4 mb-2 bg-white col-sm-12 sm:px-0 sm:py-0 question blue lighten-5 sm:rounded-none rounded-2xl" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_63 = ["for"]
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_66 = ["for"]

import {ref} from "vue";
import {client} from '@/shared';
import {GradeQuiz, GradeQuizResponse, QuestionToGrade} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {store} from "@/store";
import SaSocialShare from "@/main/components/SaSocialShare.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TakeQuiz',
  props: {
    quiz: {}
  },
  setup(__props: any) {

const props = __props;
const quiz = ref(props.quiz);

const quizToGrade = ref(new GradeQuiz({
    quizId: quiz.value.id,
    questions: quiz.value.questions.map( (q:any) => new QuestionToGrade({
        id: q.id,
        selectedAnswers: []
    }))
}));

const isAuthenticated = ref(store.saUserSession.isAuthenticated);

const responseStatus = ref(null);
const takeQuizSuccessful = ref(false);
const isSubmitting = ref(false);
const submit = async () => {
    if (!isAuthenticated.value) {
        store.showLoginDialog = true;
        return;
    }
    isSubmitting.value = true;
    takeQuizSuccessful.value = false;
    await client.post<GradeQuizResponse>(quizToGrade.value)
        .then(response => {
            takeQuizSuccessful.value = true;
            window.location.href = `/${response.quizId}/grade`;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_sa_walled = _resolveComponent("sa-walled")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("ol", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("li", { class: "flex" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("a", {
                    class: "ml-4 text-sm font-medium text-zinc-200 hover:text-zinc-100",
                    href: "/quizzes"
                  }, "All Quizzes")
                ])
              ], -1)),
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("svg", {
                    "aria-hidden": "true",
                    class: "w-6 h-full shrink-0 text-clay-700",
                    fill: "currentColor",
                    preserveAspectRatio: "none",
                    viewBox: "0 0 24 44",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", { d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(quiz.value.title), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("header", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "block sm:hidden" }, [
                      _createElementVNode("a", {
                        href: "/quizzes",
                        class: "px-2 py-1 mb-4 text-xs border rounded-lg text-clay-600 hover:shadow"
                      }, "Back to Quiz Search")
                    ], -1)),
                    _createElementVNode("h1", _hoisted_15, _toDisplayString(quiz.value.title), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(quiz.value.description), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "items-center text-center" }, null, -1)),
                    (quiz.value.guides?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-2 space-x-2 text-sm text-clay-800" }, "Guides associated with this quiz:", -1)),
                          _createElementVNode("p", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value.guides, (guide) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: guide.id,
                                href: `/${guide.id}`,
                                class: "inline-flex items-center rounded-full bg-clay-200 hover:border px-3 py-0.5 text-sm text-clay-950"
                              }, _toDisplayString(guide.title), 9, _hoisted_19))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs" }, "keywords: ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value.tags, (tag) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: tag,
                          href: `/search?term=${encodeURIComponent(tag)}&category=quizzes`,
                          class: "inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100"
                        }, _toDisplayString(tag), 9, _hoisted_21))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(SaSocialShare, {
                          title: quiz.value.title
                        }, null, 8, ["title"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("main", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("section", null, [
                              (!isAuthenticated.value)
                                ? (_openBlock(), _createElementBlock("form", _hoisted_36, [
                                    _createVNode(_component_sa_walled, {
                                      "content-for": "AtLeastBasic",
                                      class: "max-w-3xl mx-auto"
                                    }, {
                                      teaser: _withCtx(() => [
                                        _createElementVNode("section", _hoisted_37, [
                                          _createElementVNode("div", _hoisted_38, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value.questions.slice(0, 3), (question, questionIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: question.id,
                                                class: "question text-clay-950/50"
                                              }, [
                                                _createElementVNode("div", _hoisted_39, [
                                                  _createElementVNode("p", _hoisted_40, _toDisplayString(question.title), 1),
                                                  (question.hasImageUrl)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                        _createElementVNode("div", _hoisted_42, [
                                                          _createElementVNode("figure", _hoisted_43, [
                                                            _createElementVNode("img", {
                                                              alt: question.title,
                                                              src: question.imageUrl,
                                                              class: "m-0 rounded figure-img img-fluid"
                                                            }, null, 8, _hoisted_44)
                                                          ])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_45, [
                                                  (question.type === 'multiselect')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                        _cache[6] || (_cache[6] = _createElementVNode("em", null, "Check all that apply.", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                                                          return (_openBlock(), _createElementBlock("fieldset", {
                                                            key: answer.id,
                                                            class: "space-x-3"
                                                          }, [
                                                            _withDirectives(_createElementVNode("input", {
                                                              id: answer.id,
                                                              "onUpdate:modelValue": ($event: any) => ((quizToGrade.value.questions[questionIndex].selectedAnswers) = $event),
                                                              value: answer.id,
                                                              type: "checkbox"
                                                            }, null, 8, _hoisted_47), [
                                                              [_vModelCheckbox, quizToGrade.value.questions[questionIndex].selectedAnswers]
                                                            ]),
                                                            _createElementVNode("label", {
                                                              for: answer.id
                                                            }, _toDisplayString(answer.text), 9, _hoisted_48)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                                                          return (_openBlock(), _createElementBlock("fieldset", {
                                                            key: answer.id,
                                                            class: "space-x-3"
                                                          }, [
                                                            _withDirectives(_createElementVNode("input", {
                                                              id: answer.id,
                                                              "onUpdate:modelValue": ($event: any) => ((quizToGrade.value.questions[questionIndex].selectedAnswers) = $event),
                                                              value: answer.id,
                                                              type: "radio"
                                                            }, null, 8, _hoisted_50), [
                                                              [_vModelRadio, quizToGrade.value.questions[questionIndex].selectedAnswers]
                                                            ]),
                                                            _createElementVNode("label", {
                                                              for: answer.id
                                                            }, _toDisplayString(answer.text), 9, _hoisted_51)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]),
                                      "content-title": _withCtx(() => [
                                        _cache[7] || (_cache[7] = _createTextVNode(" to take the quiz ")),
                                        _createElementVNode("span", _hoisted_52, _toDisplayString(quiz.value.title), 1),
                                        _cache[8] || (_cache[8] = _createTextVNode(" and to unlock other amazing theatre resources! "))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("form", _hoisted_53, [
                                    _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value.questions, (question, questionIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: question.id,
                                        class: "px-5 py-3 mb-2 bg-white sm:px-0 sm:py-0 question sm:rounded-none rounded-2xl prose prose-lg prose-slate"
                                      }, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("h4", _hoisted_55, _toDisplayString(question.title), 1),
                                          (question.hasImageUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                _createElementVNode("div", _hoisted_57, [
                                                  _createElementVNode("figure", _hoisted_58, [
                                                    _createElementVNode("img", {
                                                      alt: question.title,
                                                      src: question.imageUrl,
                                                      class: "m-0 rounded figure-img img-fluid"
                                                    }, null, 8, _hoisted_59)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_60, [
                                          (question.type === 'multiselect')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                _cache[9] || (_cache[9] = _createElementVNode("em", null, "Check all that apply.", -1)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                                                  return (_openBlock(), _createElementBlock("fieldset", {
                                                    key: answer.id,
                                                    class: "space-x-3"
                                                  }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      id: answer.id,
                                                      "onUpdate:modelValue": ($event: any) => ((quizToGrade.value.questions[questionIndex].selectedAnswers) = $event),
                                                      value: answer.id,
                                                      type: "checkbox"
                                                    }, null, 8, _hoisted_62), [
                                                      [_vModelCheckbox, quizToGrade.value.questions[questionIndex].selectedAnswers]
                                                    ]),
                                                    _createElementVNode("label", {
                                                      for: answer.id
                                                    }, _toDisplayString(answer.text), 9, _hoisted_63)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                                                  return (_openBlock(), _createElementBlock("fieldset", {
                                                    key: answer.id,
                                                    class: "space-x-3"
                                                  }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      id: answer.id,
                                                      "onUpdate:modelValue": ($event: any) => ((quizToGrade.value.questions[questionIndex].selectedAnswers) = $event),
                                                      value: answer.id,
                                                      type: "radio"
                                                    }, null, 8, _hoisted_65), [
                                                      [_vModelRadio, quizToGrade.value.questions[questionIndex].selectedAnswers]
                                                    ]),
                                                    _createElementVNode("label", {
                                                      for: answer.id
                                                    }, _toDisplayString(answer.text), 9, _hoisted_66)
                                                  ]))
                                                }), 128))
                                              ]))
                                        ])
                                      ]))
                                    }), 128)),
                                    _createVNode(SaButton, {
                                      id: "btnGradeQuiz",
                                      onClick: _withModifiers(submit, ["prevent"]),
                                      loading: isSubmitting.value,
                                      variant: "primary"
                                    }, {
                                      loading: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createElementVNode("span", { class: "font-semibold" }, "Grading...", -1)
                                      ])),
                                      default: _withCtx(() => [
                                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-semibold" }, "Grade Quiz", -1))
                                      ]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex hidden mb-12 overflow-visible w-80" }, [
                  _createElementVNode("div", { class: "" }, [
                    _createElementVNode("div", { class: "relative inset-0 px-4 pb-6 sm:px-6 lg:px-8" })
                  ])
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})